import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MyDatePickerModule } from 'mydatepicker';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/Header.component';
import { FooterComponent } from './footer/Footer.component';
import { ContainerComponent } from './container/Container.component';
import { WelcomePageComponent } from './welcome/welcome.component';
import { QuestionPageComponent } from './question/question.component';
import { ErrorPageComponent } from "./pages/error.component";
import { ThankyouComponent } from "./pages/thankyou.component";
import { ExpireComponent } from "./pages/expire.component";
import { LoadingComponent } from "./pages/loading.component";
import { HTMLGenricComponent } from "./common/JSON/htmlComponent/HTML-Genric-Component.JSON";


import { AppRoutingModule } from './router/app-routing-module';
import { SessionService } from './session.service';
import { RequestService } from "./request.service";
import { ValidatorService } from "./services/validation.service";
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxPrintModule } from 'ngx-print';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import {MatSelectModule} from "@angular/material/select";

@NgModule({
  declarations: [
    ErrorPageComponent,
    LoadingComponent,
    ExpireComponent,
    ThankyouComponent,
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ContainerComponent,
    WelcomePageComponent,
    QuestionPageComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MyDatePickerModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    MatExpansionModule,
    NgxPrintModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatSelectModule,
  ],
  providers: [SessionService, RequestService, ValidatorService, HTMLGenricComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
